import { Icon, IconProps } from './Icon';

export const AIRobotIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 32 32"
  >
    <rect
      width="32"
      height="32"
      rx="16"
      fill="#0098F0"
    />
    <path
      d="M21.0001 13.5H11.0001C9.15913 13.5 7.66675 14.9924 7.66675 16.8333V21.8333C7.66675 23.6743 9.15913 25.1667 11.0001 25.1667H21.0001C22.841 25.1667 24.3334 23.6743 24.3334 21.8333V16.8333C24.3334 14.9924 22.841 13.5 21.0001 13.5Z"
      stroke="#FEFEFE"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16.0002 10.1663C16.9206 10.1663 17.6668 9.42015 17.6668 8.49967C17.6668 7.5792 16.9206 6.83301 16.0002 6.83301C15.0797 6.83301 14.3335 7.5792 14.3335 8.49967C14.3335 9.42015 15.0797 10.1663 16.0002 10.1663Z"
      stroke="#FEFEFE"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16 10.166V13.4993M13.5 20.166V18.4993M18.5 18.4993V20.166"
      stroke="#FEFEFE"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
